<script>
	export default {
		name: 'FirestoreExecuter',
		methods: {
			getFirestoreCollection(collectionName, filter, limitCount) {
				const self_ = this;

				let ref_ = null;
				// filter
				if(self_.isObject(filter)) {
					ref_ = self_.firebase.firestore().collection(collectionName).where(filter.field, filter.operator, filter.value)
				} else {
					ref_ = self_.firebase.firestore().collection(collectionName)
				}
				// limit count
				if(self_.isFalse(limitCount)) {
					if(self_.firestoreLimitCount > 0 ) {
						return self_.$_fsExec_getCollection(ref_.limit(Number(self_.firestoreLimitCount)))
					} else {
						return self_.$_fsExec_getCollection(ref_)
					}
				} else {
					if(limitCount > 0 ) {
						return self_.$_fsExec_getCollection(ref_.limit(Number(limitCount)))
					} else {
						return self_.$_fsExec_getCollection(ref_)
					}
				}
			},
			getFirestoreDocument(collectionName, docId) {
				const self_ = this;

				const ref_ = self_.firebase.firestore().collection(collectionName).doc(docId)

				return self_.$_fsExec_getDocument(ref_)
			},
			getFirestoreSubCollection(collectionName, docId, subCollectionName) {
				const self_ = this;

				const ref_ = self_.firebase.firestore().collection(collectionName).doc(docId).collection(subCollectionName)

				return self_.$_fsExec_getCollection(ref_)
			},
			getFirestoreSubDocument(collectionName, docId, subCollectionName, subDocId) {
				const self_ = this;

				const ref_ = self_.firebase.firestore().collection(collectionName).doc(docId).collection(subCollectionName).doc(subDocId)

				return self_.$_fsExec_getDocument(ref_)
			},
			getFirestoreSubSubCollection(collectionName, docId, subCollectionName, subDocId, subSubCollectionName) {
				const self_ = this;

				const ref_ = self_.firebase.firestore().collection(collectionName).doc(docId).collection(subCollectionName).doc(subDocId).collection(subSubCollectionName)

				return self_.$_fsExec_getCollection(ref_)
			},
			getFirestoreSubSubDocument(collectionName, docId, subCollectionName, subDocId, subSubCollectionName, subSubDocId) {
				const self_ = this;

				const ref_ = self_.firebase.firestore().collection(collectionName).doc(docId).collection(subCollectionName).doc(subDocId).collection(subSubCollectionName).doc(subSubDocId)

				return self_.$_fsExec_getDocument(ref_)
			},
			addFirestoreDocument(collectionName, value) {
				const self_ = this;

				const ref_ = self_.firebase.firestore().collection(collectionName)

				return self_.$_fsExec_add(ref_, value)
			},
			setFirestoreDocument(collectionName, docId, value) {
				const self_ = this;

				const ref_ = self_.firebase.firestore().collection(collectionName).doc(docId)

				return self_.$_fsExec_set(ref_, value)
			},
			deleteFirestoreDocument(collectionName, docId) {
				const self_ = this;

				const ref_ = self_.firebase.firestore().collection(collectionName).doc(docId)

				return self_.$_fsExec_delete(ref_)
			},
			addFirestoreSubDocument(collectionName, docId, subCollectionName, value) {
				const self_ = this;

				const ref_ = self_.firebase.firestore().collection(collectionName).doc(docId).collection(subCollectionName)

				return self_.$_fsExec_add(ref_, value)
			},
			setFirestoreSubDocument(collectionName, docId, subCollectionName, subDocId, value) {
				const self_ = this;

				const ref_ = self_.firebase.firestore().collection(collectionName).doc(docId).collection(subCollectionName).doc(subDocId)

				return self_.$_fsExec_set(ref_, value)
			},
			deleteFirestoreSubDocument(collectionName, docId, subCollectionName, subDocId) {
				const self_ = this;

				const ref_ = self_.firebase.firestore().collection(collectionName).doc(docId).collection(subCollectionName).doc(subDocId)

				return self_.$_fsExec_delete(ref_)
			},
			addFirestoreSubSubDocument(collectionName, docId, subCollectionName, subDocId, subSubCollectionName, value) {
				const self_ = this;

				const ref_ = self_.firebase.firestore().collection(collectionName).doc(docId).collection(subCollectionName).doc(subDocId).collection(subSubCollectionName)

				return self_.$_fsExec_add(ref_, value)
			},
			setFirestoreSubSubDocument(collectionName, docId, subCollectionName, subDocId, subSubCollectionName, subSubDocId, value) {
				const self_ = this;

				const ref_ = self_.firebase.firestore().collection(collectionName).doc(docId).collection(subCollectionName).doc(subDocId).collection(subSubCollectionName).doc(subSubDocId)

				return self_.$_fsExec_set(ref_, value)
			},
			deleteFirestoreSubSubDocument(collectionName, docId, subCollectionName, subDocId, subSubCollectionName, subSubDocId) {
				const self_ = this;

				const ref_ = self_.firebase.firestore().collection(collectionName).doc(docId).collection(subCollectionName).doc(subDocId).collection(subSubCollectionName).doc(subSubDocId)

				return self_.$_fsExec_delete(ref_)
			},
			$_fsExec_getCollection(ref) {
				const self_ = this;

				let result_ = {}

				const get_ = doc => {
					const id_ = doc.id;
					const data_ = doc.data();

					return new Promise(resolve => {
						result_[id_] = data_;
						resolve()
					})
				}
				
				let promiseArray_ = []

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return self_.$_fsExec_get(ref)
					}).then(query => {
						if(query.size > 0) {
							query.forEach(doc => {
								promiseArray_.push(get_(doc))
							})
						}
						return Promise.all(promiseArray_)
					}).then(() => {
						resolve(result_)
					}).catch(error => {
						reject(error)
					})
				})
			},
			$_fsExec_getDocument(ref) {
				const self_ = this;

				let result_ = {}
				
				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return self_.$_fsExec_get(ref)
					}).then(doc => {
						if(doc.exists) {
							result_ = doc.data()
						}
						resolve(result_)
					}).catch(error => {
						reject(error)
					})
				})
			},
			$_fsExec_get(ref) {
				const self_ = this;

				const app_ = self_.getState('app')

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return ref.get()
					}).then(result => {
						// count for collection
						if(!self_.isFalse(result.size)) { app_.firebase.firestore.read = app_.firebase.firestore.read + result.size; }
						// count for document
						else { app_.firebase.firestore.read++; }
						
						resolve(result)
					}).catch(error => {
						reject(error)
					})
				})
				
			},
			$_fsExec_set(ref, value) {
				const self_ = this;

				const app_ = self_.getState('app')
				app_.firebase.firestore.write++;

				return ref.set(value)
			},
			$_fsExec_add(ref, value) {
				const self_ = this;

				const app_ = self_.getState('app')
				app_.firebase.firestore.write++;

				return ref.add(value)
			},
			$_fsExec_delete(ref) {
				const self_ = this;

				const app_ = self_.getState('app')
				app_.firebase.firestore.write++;

				return ref.delete()
			}
		}
	}
</script>
